export default {
    workProfiles() {
        return this.$store.state.session.favoriteWorkProfiles
    },
    favoriteIds() {
        return this.workProfiles.map(profile => {return profile['@id']})
    }
}

